import { NgModule } from '@angular/core';

import { HomeRoutingModule } from './home-routing.module';

import { HomeComponent } from './home.component';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import {
  DatePipe,
  DecimalPipe,
  I18nSelectPipe,
} from '@angular/common';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { LuxonModule } from 'luxon-angular';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { AppModule } from '../../app.module';
import { PipesModule } from '../../pipes/pipes.module';
import { ComponentsModule } from '../../components/components.module';
import { RouterLink } from '@angular/router';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { WorkBatchesComponent } from '../../components/work-batches/work-batches.component';
import { SortFilterWorkBatchesComponent } from '../../components/sort-filter-work-batches/sort-filter-work-batches.component';
import { AppDebugComponent } from '../app-debug/app-debug.component';

@NgModule({
  imports: [
    HomeRoutingModule,
    NzTableModule,
    NzDividerModule,
    NzIconModule,
    LuxonModule,
    NzGridModule,
    NzRadioModule,
    FormsModule,
    NzInputModule,
    NzSpaceModule,
    NzAutocompleteModule,
    NzButtonModule,
    PipesModule,
    ComponentsModule,
    RouterLink,
    NzTooltipModule,
    I18nSelectPipe,
    NzPopconfirmModule,
    NzTabsModule,
    DecimalPipe,
    DatePipe,
    WorkBatchesComponent,
    SortFilterWorkBatchesComponent,
    AppDebugComponent
  ],
  declarations: [HomeComponent],
  exports: [HomeComponent],
})
export class HomeModule { }
